import { RouteConfig } from 'vue-router'
import { paymentSetupRouteNames } from '@/routes/constants/location'

const PaymentSetup = () =>
  import(
    /* webpackChunkName: "agency-billing-inactive-location" */ '@/pmd/pages/agency/billing/PaymentSetup.vue'
  ).then(m => m.default)

export const paymentSetupRoute: RouteConfig[] = [
  {
    path: 'payment_setup',
    name: paymentSetupRouteNames.default,
    component: PaymentSetup,
    meta: {
      hideTopBar: false,
    },
  }
]
